<template>
  <header class="bg-white shadow-lg px-6 flex align-center">
    <div>
      <router-link to="/">
        <Logo class="inline"/>
        <Logo-text class="inline"/>
      </router-link>
    </div>
    <div class="flex-grow items-right flex items-center justify-end">
      <div class="mr-3">{{ user.username }}</div>
      <img class="rounded-full h-16 w-16 inline-block p-2" :src="user.avatar" />
      <menu-down-icon />
    </div>
  </header>
</template>

<script>
import Logo from '@/assets/images/logo.svg'
import LogoText from '@/assets/images/logoText.svg'
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue'

export default {
  name: 'Header',
  components: {
    Logo,
    LogoText,
    MenuDownIcon
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  }
}
</script>

<style scoped lang="scss">
</style>
